// NeedSupport.js
import React from 'react';
import './Homepage.css';
import { FaEnvelope, FaWhatsapp, FaQuestionCircle } from 'react-icons/fa';

function NeedSupport() {
  return (
    <div className="support-wrapper">
      {/* Primary Card */}
      <div className="support-card">
        <div className="support-icon">
          <FaQuestionCircle />
        </div>
        <h2>Need Support?</h2>
        <p>Please email us at:</p>
        <div className="support-email">support@ghrseghr.com</div>

        <div className="support-icons">
          <div className="icon gmail">
            <FaEnvelope />
          </div>
          <div className="icon whatsapp">
            <FaWhatsapp />
          </div>
        </div>
      </div>

      {/* Instruction Card */}
      <div className="instruction-card">
        <h3>📩 Read Before Contacting</h3>
        <p>To get fast support, please include these in your email:</p>
        <ul>
          <li>✅ Your full name</li>
          <li>✅ Registered email or phone</li>
          <li>✅ Clear description of the issue</li>
          <li>✅ Screenshots (if possible)</li>
        </ul>
        <p>We reply within <strong>24 hours</strong> on working days.</p>
      </div>

      {/* WhatsApp Info */}
      <div className="instruction-card whatsapp-card">
        <h3>💬 WhatsApp Support</h3>
        <p>
          Tap the WhatsApp icon above to open a chat with us.
          An auto-generated message will be prepared — just click "Send".
        </p>
        <p>⏱ Our team will try to resolve your issue within 24 hours.</p>
      </div>
    </div>
  );
}

export default NeedSupport;

